import { Departaments } from './../models/departaments.model';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { Wrapper } from '../models/wrapper.model';
import { Organization } from '../models/organization.model';
import { Setor } from '../models/setor.model';
import {
    AllowedOrganizationOutput,
    GeneralOrganizationDto,
    MemberDto,
    MemberExistsDto,
    OrganizationWithUsersOutput
} from '../models/security-contracts';

@Injectable()
export class OrganizacaoService {
    private http = inject(HttpClient);

    securityApi = `${environment.api}/svc-security/api`;

    addSetor(setor: Setor): Observable<Wrapper<number>> {
        return this.http.post<Wrapper<number>>(`${this.securityApi}/department`, setor);
    }

    exists(isAdv: boolean, cpf: string): Observable<Wrapper<MemberExistsDto>> {
        return this.http.get<Wrapper<MemberExistsDto>>(`${this.securityApi}/membro/exists?cpf=${cpf}&isAdv=${isAdv}`);
    }

    existsAny(cpf:string): Observable<Wrapper<boolean>> {
        return this.http.get<Wrapper<boolean>>(`${this.securityApi}/membro/exists-any?cpf=${cpf}`);
    }

    findSimilarDepartments(idenOgan: number, nomeSetr: string): Observable<Wrapper<Departaments[]>> {
        nomeSetr = encodeURI(nomeSetr);
        return this.http.get<Wrapper<Departaments[]>>(`${this.securityApi}/department/find-similar-departments?idenOgan=${idenOgan}&nomeSetr=${nomeSetr}`);
    }

    getMember(idenMembro: number): Observable<Wrapper<MemberDto>> {
        return this.http.get<Wrapper<MemberDto>>(`${this.securityApi}/membro/${idenMembro}`);
    }

    getMemberPhoto(idenMembro: number): Observable<Wrapper<string>> {
        return this.http.get<Wrapper<string>>(`${this.securityApi}/membro/photo/${idenMembro}`);
    }

    getOrganization(idenOgan: number): Observable<Wrapper<Organization[]>> {
        return this.http.get<Wrapper<Organization[]>>(`${this.securityApi}/organization/byids?organizationIds=${idenOgan}&includeParent=false`);
    }

    getSectorName(idenOgan:number, codiSetr:number) : Observable<Wrapper<string>> {
        return this.http.get<Wrapper<string>>(`${this.securityApi}/department/name?idenOgan=${idenOgan}&codiSetr=${codiSetr}`);
    }

    list(currentIdenOgan: number): Observable<Wrapper<AllowedOrganizationOutput[]>> {
        return this.http.get<Wrapper<AllowedOrganizationOutput[]>>(`${this.securityApi}/authorization/allowed-organizations`);
    }

    // Item 1.1: organizações que possuem ao menos um usuário vinculado (filtro da tela de Usuários).
    organizationsWithUsers(): Observable<Wrapper<OrganizationWithUsersOutput[]>> {
        return this.http.get<Wrapper<OrganizationWithUsersOutput[]>>(`${this.securityApi}/authorization/organizations-with-users`);
    }

    listChildren(idenOganParent: number): Observable<Wrapper<GeneralOrganizationDto[]>> {
        return this.http.get<Wrapper<GeneralOrganizationDto[]>>(`${this.securityApi}/organization/children/${idenOganParent}`);
    }

    recuperarNomes(lista: { idenOgan: number, codiSetr: number }[]): Observable<Wrapper<OrgaoSetor[]>> {
        const params = lista.map(i => {
            return `idenOgan_codiSetr=${i.idenOgan},${i.codiSetr}`;
        }).join('&');

        return this.http.get<Wrapper<OrgaoSetor[]>>(`${this.securityApi}/department/names?${params}`);
    }
}

export interface OrgaoSetor {

    idenOgan: number;
    codiSetr: number;
    nomeOgan: string;
    nomeSetr: string;

}
